import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useCallback } from 'react';
import { z } from 'zod';
import { useComposableFilter } from '@/components/ComposableFilter';
import { AllSearchFilterBar } from '@/features/contract-and-cost/deal';
import { usePaginationSearch } from '@/lib/listPage';
import { AllDealTable } from '@/routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/-components/AllDealTable';
import { useAllDealList } from '@/routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/-query';
const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional()
});
export const Route = createFileRoute('/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/')({
  component: AllTab,
  validateSearch: zodValidator(SearchSchema)
});
type EmptyFilter = Record<string, never>;
function AllTab() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const filter = useComposableFilter<EmptyFilter>({
    filterDefs: [],
    filterState: {} as EmptyFilter,
    onFilterStateChange: () => {}
  });
  const [pagination, setPagination] = usePaginationSearch({
    search,
    onSearchChange: s => navigate({
      search: s
    })
  });
  const {
    data,
    isPending
  } = useAllDealList({
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    freeText: search.freeText
  });
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    navigate({
      search: prev => ({
        ...prev,
        freeText: e.target.value || undefined,
        pageIndex: 0
      })
    });
  }, [navigate]);
  return <>
      <AllSearchFilterBar searchValue={search.freeText ?? ''} onSearchChange={handleSearchChange} filter={filter} />
      <AllDealTable data={data?.items ?? []} isPending={isPending} totalCount={data?.count} pageCount={data?.maxPage} pagination={pagination} onPaginationChange={setPagination} hideDeviceColumn className="flex-1 min-h-0" />
    </>;
}